module.exports = __webpack_public_path__ + "static/Rebecca-0ca7ff198a72d858133e8a1495d3b8fb.png";